import { createContext } from 'react';

export const AuthContext = createContext({
  isAdmin: false,
  userId: null,
  token: null,
  userName: null,
  login: () => {},
  logout: () => {},
});
